/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Tue Nov 07 2023
 **/

import { DependencyList } from "react";

import { useEventHandlers } from "@rfice/eventhandler";
import { EventHandler } from "@rfice/eventhandler";

import { EventID } from "../commons";

export default function useUnityHandler(caller: string, events?: IPC.UnityEvents, deps: DependencyList = []) {
	useEventHandlers(
		{
			[EventID.onUnityMessage](message: Message.Frame) {
				switch (message.type) {
					case "ready": {
						events?.onReady?.(message.payload);
						break;
					}
					case "request": {
						events?.onRequest?.(message.payload);
						break;
					}

					case "spaceStatus": {
						events?.onSpaceStatus?.(message.payload);

						if (Object.hasOwn(message.payload, "currentScene")) {
							events?.onChangeSpace?.(message.payload);
						}
						break;
					}

					case "responseRenderTexture": {
						events?.onResponseRenderTexture?.(message.payload);
						break;
					}

					case "changeScreenMode": {
						const { mode } = message.payload;
						events?.onChangeScreenMode?.(mode);
						break;
					}

					case "enterSpace": {
						events?.onEnterSpace?.(message.payload);
						break;
					}

					case "exitSpace": {
						events?.onExitSpace?.(message.payload);
						break;
					}

					case "myLocation": {
						events?.onMyLocation?.(message.payload);
						break;
					}

					case "returnMsg": {
						break;
					}

					case "actionRequest": {
						events?.onActionRequest?.(message.payload);
						break;
					}

					case "showToastMessage": {
						events?.onShowToastMessage?.(message.payload);
						break;
					}

					case "showPopupMessage": {
						events?.OnShowPopupMessage?.(message.payload);
						break;
					}

					case "requestFileUpload": {
						events?.onRequestFileUpload?.(message.payload);
						break;
					}

					case "openMiniProfile": {
						events?.onOpenMiniProfile?.(message.payload);
						break;
					}

					case "closeMiniProfile": {
						events?.onCloseMiniProfile?.(message.payload);
						break;
					}

					case "openObjectPanel": {
						events?.onOpenObjectPanel?.(message.payload);
						break;
					}

					case "closeObjectPanel": {
						events?.onCloseObjectPanel?.(message.payload);
						break;
					}

					case "focusUnity": {
						events?.onFocusUnity?.(message.payload);
						break;
					}

					case "settingBackPressed": {
						events?.onSettingBackPressed?.(message.payload);
						break;
					}

					case "unitySoundVolumeStatus": {
						events?.onUnitySoundVolume?.(message.payload);
						break;
					}
					case "changeAudioZoneState": {
						events?.onChangeAudioZoneState?.(message.payload);
						break;
					}
					case "requestFileDownload": {
						events?.onRequestFileDownload?.(message.payload);
						break;
					}

					case "requestOpenUrl": {
						events?.onRequestOpenUrl?.(message.payload);
						break;
					}

					case "createDMRoom": {
						events?.onCreateDMRoom?.(message.payload);
						break;
					}

					case "unityDeviceStatusChanged": {
						events?.onUnityDeviceStatusChanged?.(message.payload);
						break;
					}

					case "screenCapture": {
						EventHandler.fire("$ScreenCapture::Requested$", message.payload);
						break;
					}

					case "requestVideoChatRecord": {
						events?.onRequestVideoChatRecord?.(message.payload);
						break;
					}

					case "fileUploadAbort": {
						events?.onFileUploadAbort?.(message.payload);
						break;
					}

					case "runBackgroundProcess": {
						events?.onRunBackgroundProcess?.(message.payload);
						break;
					}

					case "userKnock": {
						events?.onUserKnock?.(message.payload);
						break;
					}

					case "refreshToken": {
						events?.onRequestRefreshToken?.(message.payload);
						break;
					}

					case "runWhiteboard": {
						events?.onRunWhiteboard?.(message.payload);
						break;
					}

					case "joinWhiteboard": {
						events?.onJoinWhiteboard?.(message.payload);
						break;
					}

					case "requestCloseWhiteboard": {
						events?.onRequestCloseWhiteboard?.(message.payload);
						break;
					}

					case "changeWhiteboardZoneState": {
						events?.onChangeWhiteboardZoneState?.(message.payload);
						break;
					}

					case "fileShareStopped": {
						events?.onFileShareStopped?.(message.payload);
						break;
					}

					default: {
						console.debug(`#useUnityHandler ${caller}# onUnityMessage in default`, message);
						break;
					}
				}
			},
			[EventID.onUnityRenderTexture](index: number, gl: WebGLRenderingContext, texture: WebGLTexture) {
				events?.onRenderTexture?.(index, gl, texture);
			}
		},
		deps
	);
}
